<template lang="pug">
  .page-container
    Toolbar
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container(v-if='isLoading')
      Loading

    v-container(v-if='!isLoading')
      table.order-table
        thead
          tr
            th {{ $t("order.orderNo") }}
            th {{ $t("order.status") }}
            th {{ $t("order.orderDate") }}

        tbody
          tr(v-for='(item, index) in list' @click="$router.push({name: 'order-detail', params: {orderId: item.orderId}})")
            td {{item.sn}}
            td {{item.flagText}}
            td {{item.createTime}}

      .pagination-container
        v-pagination(v-model="page" :length="totalPages" circle total-visible=8 @input="loadOrderList")

</template>

<script>
import Toolbar from "../../components/common/toolbar";
import order from "../../api/order.js";
import Loading from "../../components/common/loading";

export default {
  data() {
    return {
      list: [],
      totalPages: null,
      page: 1,
      isLoading: true
    };
  },
  mounted() {
    this.loadOrderList();
  },
  computed: {
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "order-list" },
          disabled: true,
          text: this.$t("nav.order")
        }
      ];
    }
  },
  components: {
    Toolbar,
    Loading
  },
  methods: {
    async loadOrderList() {
      this.isLoading = true;
      try {
        const res = await order.orderList({ page: this.page });
        this.isLoading = false;
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          console.log(res.data.data);
          this.list = res.data.data.list;
          this.totalPages = res.data.data.totalPages;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped lang="sass" src="./list.sass"></style>
